import i18n from "@plugins/i18n";
import { notNull } from "@utils/var.check";

/*
 * Wrapper custom plugin to allow us to customize when the toggle button to be disabled
 * */
export default function (editor) {
  const richTextEditor = editor.options.get("richTextEditor");
  (function init() {
    richTextEditor.plugins["mylink"] = {
      renderInEditor,
      cleanUp,
      containPluginElements,
    };
  })();

  function renderInEditor() {}

  function cleanUp(content) {
    return content;
  }

  function containPluginElements() {
    return false;
  }

  editor.ui.registry.addToggleButton("mylink", {
    tooltip: i18n.t("tinymce_plugin_mylink_icon_button_tooltip"),
    icon: "link",
    onAction: handleClickAction,
    onSetup: handleLinkElementSelected,
  });

  function handleClickAction() {
    editor.execCommand("mceLink");
  }

  function handleLinkElementSelected(buttonApi) {
    const nodeChangeHandler = function () {
      let content = editor.selection.getContent(),
        node = editor.selection.getNode(),
        nodeName = node.nodeName,
        nodeClass = node.getAttribute("class");

      if (!nodeClass) {
        nodeClass = "";
      }
      const isDisabled =
        nodeName != "P" || nodeName == "DIV"
          ? (notNull(nodeClass) && nodeClass.includes("media-component")) ||
            content.includes("media-component")
          : content.includes("media-component");
      buttonApi.setEnabled(!isDisabled);
      buttonApi.setActive(getAnchorElement(editor, editor.selection.getNode()) !== null);
    };

    // onSetup should always return the unbind handlers.
    editor.on("NodeChange", nodeChangeHandler);
    return function () {
      return editor.off("NodeChange", nodeChangeHandler);
    };
  }
  //copied from existing link plugin
  function getAnchorElement(editor, selectedElm) {
    selectedElm = selectedElm || editor.selection.getNode();
    if (isImageFigure(selectedElm)) {
      return editor.dom.select("a[href]", selectedElm)[0];
    } else {
      return editor.dom.getParent(selectedElm, "a[href]");
    }
  }
  //copied from existing link plugin
  function isImageFigure(elm) {
    return elm && elm.nodeName === "FIGURE" && /\bimage\b/i.test(elm.className);
  }
}
